import(/* webpackMode: "eager" */ "/Users/arthurtanoh/Documents/Work/Bool technology/cosa/site/cosa_sante/src/app/services/analyses-biomedicales/page.tsx");
